import { set, get } from "./state.js";
import useGrpc from "./grpc.js";
const { ping } = useGrpc();
// import {useAuth} from "./firebase.js";
// const auth = useAuth();

export var app = {
  home: "https://itpcareerexpo.com/",
  env: "DEVELOPMENT", // or 'PRODUCTION' for no logging output
  cdn: "https://images.itpcareerexpo.com/",
  login: "https://itpcareerexpo.com/login/",
  signup: "https://itpcareerexpo.com/registration/",
};

export const checkServer = async () => {
  try {
    const res = await ping();
    if (!res) throw new Error("Server Ping Failed");
    if (res.code !== "pong") throw new Error("Server Ping Failed");
  } catch (err) {
    console.error(err);
    return false;
  }

  return true;
};

export function escapeHtml(html) {
  const text = document.createTextNode(html);
  const p = document.createElement("p");
  p.appendChild(text);
  return p.innerHTML;
}

export const setUser = async () => {
  const user = auth.getCurrentUser();
  if (!user) return false;

  const data = await grpc.getUserData();
  console.log("USERDATA", data);
  if (!data) return false;

  const score = await grpc.getUserScore();
  console.log("SCORE", score);
  if (!score) return false;

  const success = storeAccountData(data.user, score.score);

  return true;
};

// returns true if all required fields were successfully stored
function storeAccountData(userData, score) {
  let success = true;

  if (!set("id", userData.userId)) return (success = false);
  if (!set("email", userData.email)) return (success = false);
  if (!set("accountType", userData.accountType)) return (success = false);
  if (!set("username", userData.leaderboardName)) return (success = false);
  if (!set("fname", userData.firstName)) return (success = false);
  if (!set("lname", userData.lastName)) return (success = false);
  if (!set("grade", userData.grade)) return (success = false);
  if (!set("score", score)) return (success = false);
  if (!set("school", userData.school)) return (success = false);
  if (!set("county", userData.county)) return (success = false);
  if (!set("interestedPathways", JSON.stringify(userData.pathwaysList)))
    return (success = false);
  if (!set("timestamp", Math.floor(Date.now() / 1000)))
    return (success = false);

  return success;
}

export function loggedIn() {
  // id of currently logged in user
  const id = get("id");

  // guard against "null" string that can happen with localStorage.setItem
  if (
    typeof id === "string" &&
    id.length > 0 &&
    id !== "null" &&
    id !== "undefined"
  ) {
    return true;
  }

  return false;
}

export function updateProgressBar(evt) {
  const trigger = document.querySelector("#itp-trigger-progress-bar-display");

  if (trigger != null) {
    trigger.click();
  }

  const widgetContainer = document.querySelector(
    ".itp-progress-bar .elementor-widget-container"
  );
  const imageContainer = widgetContainer.querySelector(".elementor-image");

  if (widgetContainer == null) {
    return;
  }

  if (loggedIn()) {
    if (get("grade") != "3" && get("accountType") != "2") {
      const leaderboardLink = document.querySelector(".itp-leaderboard-link");
      leaderboardLink.remove();
    }

    widgetContainer.removeChild(imageContainer);

    widgetContainer.style.position = "relative";
    widgetContainer.style.height = "150px";

    console.log("Hi from the progress bar updater!");

    let progressContainer = document.createElement("div");
    progressContainer.style.width = "100%";
    progressContainer.style.position = "absolute";
    progressContainer.style.top = "65px";
    progressContainer.style.height = "20px";
    progressContainer.style.backgroundColor = "#bad533";

    widgetContainer.appendChild(progressContainer);

    let maxWidth = progressContainer.offsetWidth;

    //620 point-long max bar so maxWidth/620 gives the pixel width for a single point out of 620.
    let widthUnit = maxWidth / 620;

    let score = get("score");

    //score times actual pixel width if less than width of bar
    let progressWidth =
      score <= 620 ? (score < 0 ? 0 : score * widthUnit) : maxWidth;

    let progressBar = document.createElement("div");
    progressBar.style.backgroundColor = "#cd6cab";
    progressBar.style.height = "100%";
    progressBar.style.width = progressWidth + "px";

    progressContainer.appendChild(progressBar);

    let levelFolder = "score-levels/";
    let level1 = "level1a";
    let level2 = "level2a";
    let level3 = "level3a";
    let level4 = "level4a";
    let level5 = "level5a";

    let level1Ext = score >= 120 && score < 220 ? ".gif" : ".png";
    let level2Ext = score >= 220 && score < 320 ? ".gif" : ".png";
    let level3Ext = score >= 320 && score < 420 ? ".gif" : ".png";
    let level4Ext = score >= 420 && score < 520 ? ".gif" : ".png";
    let level5Ext = score >= 520 ? ".gif" : ".png";

    let levelNumBuff = 48;

    let level1Img = document.createElement("img");
    level1Img.src = app.cdn + levelFolder + level1 + level1Ext;
    level1Img.style.left = (120 - levelNumBuff) * widthUnit + "px";
    level1Img.style.position = "absolute";
    level1Img.style.top = "0px";
    widgetContainer.appendChild(level1Img);

    let level2Img = document.createElement("img");
    level2Img.src = app.cdn + levelFolder + level2 + level2Ext;
    level2Img.style.left = (220 - levelNumBuff) * widthUnit + "px";
    level2Img.style.position = "absolute";
    level2Img.style.top = "0px";
    widgetContainer.appendChild(level2Img);

    let level3Img = document.createElement("img");
    level3Img.src = app.cdn + levelFolder + level3 + level3Ext;
    level3Img.style.left = (320 - levelNumBuff) * widthUnit + "px";
    level3Img.style.position = "absolute";
    level3Img.style.top = "0px";
    widgetContainer.appendChild(level3Img);

    let level4Img = document.createElement("img");
    level4Img.src = app.cdn + levelFolder + level4 + level4Ext;
    level4Img.style.left = (420 - levelNumBuff) * widthUnit + "px";
    level4Img.style.position = "absolute";
    level4Img.style.top = "0px";
    widgetContainer.appendChild(level4Img);

    let level5Img = document.createElement("img");
    level5Img.src = app.cdn + levelFolder + level5 + level5Ext;
    level5Img.style.left = (520 - levelNumBuff) * widthUnit + "px";
    level5Img.style.position = "absolute";
    level5Img.style.top = "0px";
    widgetContainer.appendChild(level5Img);

    console.log("Widget Container:");
    console.log(widgetContainer);
    console.log("Progress Container:");
    console.log(progressContainer);
  } else {
    const leaderboardLink = document.querySelector(".itp-leaderboard-link");
    leaderboardLink.remove();
  }

  evt.preventDefault();
}

export function updateScoreDisplay() {
  const trigger = document.querySelector("#itp-trigger-score-display");

  if (trigger != null) {
    trigger.click();
  }

  const score = document.querySelector(
    ".itp-my-score h2.elementor-heading-title"
  );

  if (score == null) {
    return;
  }

  if (loggedIn()) {
    let points = get("score");

    if (
      points == null ||
      points === "" ||
      points === "NULL" ||
      points === "null" ||
      points === "undefined"
    ) {
      points = "0";
    }

    score.textContent = points;
  } else {
    score.textContent = "0";
  }

  const progressBarToggle = document.querySelector("#itp-show-progress-bar");

  if (progressBarToggle == null) {
    return;
  }

  progressBarToggle.onclick = updateProgressBar;
}

export async function updateMenu() {
  const serverGood = await checkServer();
  // await auth.ready();
  // setTimeout(() => {
  const loginMenu = document.querySelector(
    ".itp-loginlogout-menu > a.elementor-item"
  );
  const leaderboardMenu = document.querySelector(".itp-leaderboard-menu");

  if (leaderboardMenu != null) {
    if (loggedIn() && (get("grade") === "3" || get("accountType") == "2")) {
      leaderboardMenu.style.display = "block";
    }

    // if server bad - add banner below menu
    if (!serverGood) {
      const banner = document.createElement("div");
      banner.className = "itp-server-bad-banner";
      banner.textContent = "Server is not responding. Please contact support.";
      banner.style.backgroundColor = "red";
      banner.style.color = "white";
      banner.style.textAlign = "center";
      banner.style.padding = "5px";
      banner.style.margin = "5px";
      banner.style.borderRadius = "5px";
      banner.style.fontWeight = "bold";
      banner.style.fontSize = "1.5em";
      banner.style.display = "block";
      banner.style.width = "100%";
      banner.style.boxSizing = "border-box";

      leaderboardMenu.parentNode.insertBefore(banner, leaderboardMenu);
    }
  }

  if (loginMenu == null) {
    return;
  }

  if (loggedIn()) {
    loginMenu.textContent = "Logout";
    loginMenu.href = "/logout/";
  } else {
    loginMenu.textContent = "Login";
    loginMenu.href = "/login/";
  }
  // }, 1000);
}

export function init(evt) {
  alertify.set("notifier", "position", "bottom-center");

  updateMenu();
  updateScoreDisplay();
}

export function load(evt) {
  updateScoreDisplay();
}

export default {};
